var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2715 9.74434V14.7443C13.2715 15.1864 13.0959 15.6103 12.7833 15.9229C12.4708 16.2354 12.0468 16.411 11.6048 16.411H2.43815C1.99612 16.411 1.5722 16.2354 1.25964 15.9229C0.947079 15.6103 0.771484 15.1864 0.771484 14.7443V5.57768C0.771484 5.13565 0.947079 4.71173 1.25964 4.39917C1.5722 4.08661 1.99612 3.91101 2.43815 3.91101H7.43815M10.7715 1.41101H15.7715M15.7715 1.41101V6.41101M15.7715 1.41101L6.60482 10.5777",
    stroke: "#71C6FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/openLink.d8f87181a6f67328ae19757d8a872730.svg";
export { ForwardRef as ReactComponent };